var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalWizard3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102 41",
    style: {
      enableBackground: "new 0 0 102 41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#E6E6E6;}\r\n\t.st1{fill:none;stroke:#E6E6E6;}\r\n\t.st2{fill:none;stroke:#E6E6E6;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:none;stroke:#DADADA;stroke-miterlimit:10;}\r\n\t.st5{fill:#E6E6E6;}\r\n\t.st6{fill:none;stroke:#0072C6;stroke-width:2;}\r\n\t.st7{fill:#0072C6;stroke:#0072C6;stroke-miterlimit:10;}\r\n\t.st8{fill:#E6E6E6;stroke:#E6E6E6;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st9{fill:#0072C6;}\r\n\t.st10{fill:none;stroke:#0072C6;}\r\n\t.st11{fill:#E5E1DF;}\r\n\t.st12{fill:#F15A24;}\r\n\t.st13{fill:none;stroke:#F15A24;}\r\n\t.st14{opacity:0.6;fill:none;stroke:#D3D3D3;}\r\n\t.st15{fill:#D3D3D3;}\r\n\t.st16{fill:#616160;}\r\n\t.st17{fill:none;stroke:#616160;}\r\n\t.st18{fill:#FFFFFF;stroke:#DADADA;stroke-miterlimit:10;}\r\n\t.st19{opacity:0.5;}\r\n\t.st20{fill:none;stroke:#0072C6;stroke-miterlimit:10;}\r\n\t.st21{fill:none;stroke:#D3D3D3;}\r\n\t.st22{fill:none;stroke:#C4C4C4;stroke-width:0.5;}\r\n\t.st23{fill:#C4C4C4;}\r\n\t.st24{fill:none;stroke:#C4C4C4;stroke-width:2;}\r\n\t.st25{fill:#C5C4C4;}\r\n\t.st26{fill:none;}\r\n\t.st27{fill:#FFFFFF;stroke:#C4C4C4;stroke-miterlimit:10;}\r\n\t.st28{opacity:0.6;}\r\n\t.st29{fill:#006837;}\r\n\t.st30{opacity:0.6;fill:none;stroke:#D3D3D3;enable-background:new    ;}\r\n\t.st31{opacity:0.5;fill:#D3D3D3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M22.4445,10.5199c-0.9081,0.9081-1.8162,1.8162-2.7243,2.7243c-0.4252-0.4252-0.8505-0.8505-1.2757-1.2757"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M20.4445,7.6663c2.3246,0,4.2157,1.8912,4.2157,4.2157s-1.8912,4.2157-4.2157,4.2157 s-4.2157-1.8912-4.2157-4.2157S18.1199,7.6663,20.4445,7.6663 M20.4445,6.6663c-2.8806,0-5.2157,2.3352-5.2157,5.2157 s2.3352,5.2157,5.2157,5.2157c2.8806,0,5.2157-2.3352,5.2157-5.2157S23.325,6.6663,20.4445,6.6663L20.4445,6.6663z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M39.7362,6.6663c-2.8806,0-5.2157,2.3352-5.2157,5.2157s2.3352,5.2157,5.2157,5.2157 c2.8806,0,5.2157-2.3352,5.2157-5.2157S42.6167,6.6663,39.7362,6.6663L39.7362,6.6663z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 59.0279,
    cy: 11.882,
    r: 5.2157
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 78.3196,
    cy: 11.882,
    r: 5.2157
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.5562,
    y: 24.4367,
    className: "st31",
    width: 75,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5562,
    y: 31.7176,
    className: "st31",
    width: 75,
    height: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalWizard3);
export default __webpack_public_path__ + "static/media/HorizontalWizard3.41c5d0321ba571c6132d13ac0be004f6.svg";
export { ForwardRef as ReactComponent };